import { MailToSystemAdminSupportLink } from '../../../components/shared/MailToSystemAdminSupportLink';

export interface IAlertListTooManyRecordsNotificationProps {
    maxRecordCount: number;
}

export function AlertListTooManyRecordsNotification(
    props: IAlertListTooManyRecordsNotificationProps
) {
    return (
        <div className="mt-2">
            <p>
                Your search filter returned more than {props.maxRecordCount.toLocaleString('en-US')}{' '}
                records, which is over our display limit. Please refine your search and try again.
                Note that Case Triggers may be driving the most volume so removing Case Triggers
                (Type) from your Search could reduce the volume records returned to avoid the
                display limit.
            </p>
            <p>
                If you did not run this search by error, or if you need help managing your volume of
                Case Triggers, please contact <MailToSystemAdminSupportLink />.
            </p>
        </div>
    );
}
